/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Review_Ready_For_InspectionInputs */

const en_orders_review_ready_for_inspection = /** @type {(inputs: Orders_Review_Ready_For_InspectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ready for Inspection`)
};

const es_orders_review_ready_for_inspection = /** @type {(inputs: Orders_Review_Ready_For_InspectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listo para inspeccion`)
};

/**
* | output |
* | --- |
* | "Ready for Inspection" |
*
* @param {Orders_Review_Ready_For_InspectionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_review_ready_for_inspection = /** @type {((inputs?: Orders_Review_Ready_For_InspectionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Review_Ready_For_InspectionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_review_ready_for_inspection(inputs)
	return es_orders_review_ready_for_inspection(inputs)
});